export default __webpack_public_path__ + "static/media/PaginaWeb.b66820fa.svg";